export default {

  LOAD_MEMBERS (state, data) {
    state.list = data.data
    state.listInfo = data
  },

  LOAD_MEMBERS_ALL (state, data) {
    state.listAll = data.data
  },

  LOAD_MEMBER (state, data) {
    state.memberInfo = { ...data }
  },

  LOAD_MEMBER_DETAIL (state, data) {
    state.memberInfo = { ...data }
  },

  REGISTER_MEMBER (state, data) {
    state.memberInfo = { ...data }
  },

  MODIFY_MEMBER (state, data) {
    state.memberInfo = { ...data }
  },

  /**
   * DKS 전용
   *
   * virtual_company 정보를 불러와서, 동국제강 내부 사용자인지 여부를 확인한다
   * 협력업체일 경우, virtual_company 값이 없거나
   * 트리 구조에 'DKSP'가 포함되어 있으면 동국제강 내부 사용자가 아니다
   */
  동국제강내부체크(state, data) {
    let isDksMember = false;
    if (data && data.virtual_company && data.virtual_company.full_code) {
      // full_code 항목 중에 'DKSP'가 없어야 한다.
      const full_code = data.virtual_company.full_code;
      if (Array.isArray(full_code) && full_code.length > 0) {
        const 협력업체여부 = full_code.filter((code) => code === 'DKSP');
        if (협력업체여부.length === 0) {
          isDksMember = true;
        }
      }
    }

    state.memberInfo.isDksMember = isDksMember;
  },

  SET_META (state, data) {
    const _meta = JSON.parse(JSON.stringify(state.meta))
    if (data.key) {
      const response = data.response
      if (response && response.length > 0) {
        // 같은 key 로 여러개 등록된 경우, 마지막 것만 사용
        const meta = response[response.length - 1]
        try {
          _meta[data.key] = JSON.parse(meta.meta_value)
        } catch (err) {
          _meta[data.key] = undefined
        }
      }
    }
    state.meta = _meta
  },

  SET_META_ALL (state, data) {
    const _meta = JSON.parse(JSON.stringify(state.meta))
    if (data && data.length > 0) {
      for (const meta of data) {
        try {
          _meta[meta.meta_key] = JSON.parse(meta.meta_value)
        } catch (err) {
          _meta[meta.meta_key] = undefined
        }
      }
    }
    state.meta = _meta
  }
}
